var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title-component" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col title" }, [
        _c("h1", [_vm._v(_vm._s(_vm.title))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row description" }, [
      _c("div", { staticClass: "col" }, [
        _c("h3", [_vm._v(_vm._s(_vm.subtitle))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23077bf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23077bf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/GuardianTitleComponent.vue
// module id = null
// module chunks = 